import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Categories
export const getCategories = () => axios.get(`${API_URL}/categories`);
export const createCategory = (data) => axios.post(`${API_URL}/categories`, data);
export const updateCategory = (id, data) => axios.put(`${API_URL}/categories/${id}`, data);
export const deleteCategory = (id) => axios.delete(`${API_URL}/categories/${id}`);

// Brands
export const getBrands = () => axios.get(`${API_URL}/brands`);
export const createBrand = (data) => axios.post(`${API_URL}/brands`, data);
export const updateBrand = (id, data) => axios.put(`${API_URL}/brands/${id}`, data);
export const deleteBrand = (id) => axios.delete(`${API_URL}/brands/${id}`);

// Vendors
export const getVendors = (activeOnly = false) => axios.get(`${API_URL}/vendors`, { params: { active_only: activeOnly } });
export const getVendor = (id) => axios.get(`${API_URL}/vendors/${id}`);
export const createVendor = (data) => axios.post(`${API_URL}/vendors`, data);
export const updateVendor = (id, data) => axios.put(`${API_URL}/vendors/${id}`, data);
export const deleteVendor = (id) => axios.delete(`${API_URL}/vendors/${id}`);

// Vendor Contacts
export const getVendorContacts = (vendorId) => axios.get(`${API_URL}/vendors/${vendorId}/contacts`);
export const createVendorContact = (vendorId, data) => axios.post(`${API_URL}/vendors/${vendorId}/contacts`, data);
export const deleteVendorContact = (contactId) => axios.delete(`${API_URL}/vendor-contacts/${contactId}`);

// Item-Vendor Pricing
export const getItemVendorPricing = (itemId) => axios.get(`${API_URL}/items/${itemId}/pricing`);
export const getAllVendorPricing = (vendorId) => axios.get(`${API_URL}/vendor-pricing`, { params: { vendor_id: vendorId } });
export const addItemVendorPricing = (itemId, data) => axios.post(`${API_URL}/items/${itemId}/pricing`, data);
export const lookupVendorPricing = (itemId, vendorId) => axios.get(`${API_URL}/pricing/lookup`, { params: { item_id: itemId, vendor_id: vendorId } });
export const updateMinimumQuantity = (stockId, minQty) => axios.patch(`${API_URL}/stock/${stockId}/minimum-quantity`, { minimum_quantity: minQty });
export const deleteItemVendorPricing = (pricingId) => axios.delete(`${API_URL}/item-pricing/${pricingId}`);

// Items
export const getItems = (params) => axios.get(`${API_URL}/items`, { params });
export const getItem = (id) => axios.get(`${API_URL}/items/${id}`);
export const createItem = (data) => axios.post(`${API_URL}/items`, data);
export const updateItem = (id, data) => axios.put(`${API_URL}/items/${id}`, data);
export const deleteItem = (id) => axios.delete(`${API_URL}/items/${id}`);
export const checkItemDuplicate = (data) => axios.post(`${API_URL}/items/check-duplicate`, data);
export const lookupStockLevel = (itemId, inventoryId) => axios.get(`${API_URL}/stock/lookup`, { params: { item_id: itemId, inventory_id: inventoryId } });

// Item Packages (now managed via Vendor Pricing)
export const getItemAvgCost = (itemId) => axios.get(`${API_URL}/items/${itemId}/avg-cost`);

// Inventories
export const getInventories = () => axios.get(`${API_URL}/inventories`);
export const getInventory = (id) => axios.get(`${API_URL}/inventories/${id}`);
export const createInventory = (data) => axios.post(`${API_URL}/inventories`, data);
export const updateInventory = (id, data) => axios.put(`${API_URL}/inventories/${id}`, data);
export const deleteInventory = (id) => axios.delete(`${API_URL}/inventories/${id}`);

// Stock
export const getStock = (params) => axios.get(`${API_URL}/stock`, { params });
export const createStock = (data) => axios.post(`${API_URL}/stock`, data);
export const updateStock = (id, data) => axios.put(`${API_URL}/stock/${id}`, data);

// Transactions
export const getTransactions = (params) => axios.get(`${API_URL}/transactions`, { params });

// Operations
export const restock = (data) => axios.post(`${API_URL}/restock`, data);
export const recordUsage = (data) => axios.post(`${API_URL}/usage`, data);
export const transfer = (data) => axios.post(`${API_URL}/transfer`, data);

// Dashboard & Reports
export const getDashboardStats = () => axios.get(`${API_URL}/dashboard/stats`);
export const getDailyUsageReport = (params) => axios.get(`${API_URL}/reports/daily-usage`, { params });
export const getJobSummary = (params) => axios.get(`${API_URL}/reports/job-summary`, { params });
export const getJobDetail = (jobNumber) => axios.get(`${API_URL}/reports/job-summary/${encodeURIComponent(jobNumber)}`);
export const getVendorAnalytics = (params) => axios.get(`${API_URL}/reports/vendor-analytics`, { params });
export const getVendorAnalyticsDetail = (vendorId, params) => axios.get(`${API_URL}/reports/vendor-analytics/${vendorId}`, { params });
export const getItemAnalytics = (params) => axios.get(`${API_URL}/reports/item-analytics`, { params });
export const getPurchaseHistory = (params) => axios.get(`${API_URL}/reports/purchases`, { params });

// Adjustments
export const createAdjustment = (data) => axios.post(`${API_URL}/adjustments`, data);
export const getAdjustments = (transactionId) => axios.get(`${API_URL}/adjustments/${transactionId}`);

// Invoice Editing
export const getInvoiceDetails = (invoiceNumber) => axios.get(`${API_URL}/invoices/${encodeURIComponent(invoiceNumber)}/details`);
export const editInvoice = (invoiceNumber, data) => axios.put(`${API_URL}/invoices/${encodeURIComponent(invoiceNumber)}`, data);
export const getInvoiceAuditTrail = (invoiceNumber) => axios.get(`${API_URL}/invoices/${encodeURIComponent(invoiceNumber)}/audit`);

// Exports
export const exportJobSummary = (params) => axios.get(`${API_URL}/export/job-summary`, { params, responseType: 'blob' });
export const exportPurchases = (params) => axios.get(`${API_URL}/export/purchases`, { params, responseType: 'blob' });
export const exportReports = (params) => axios.get(`${API_URL}/export/reports`, { params, responseType: 'blob' });
export const exportInventory = (params) => axios.get(`${API_URL}/export/inventory`, { params, responseType: 'blob' });
export const exportItems = (params) => axios.get(`${API_URL}/export/items`, { params, responseType: 'blob' });
export const exportVendors = () => axios.get(`${API_URL}/export/vendors`, { responseType: 'blob' });
export const exportUsers = () => axios.get(`${API_URL}/export/users`, { responseType: 'blob' });
export const exportCategories = () => axios.get(`${API_URL}/export/categories`, { responseType: 'blob' });
export const exportBrands = () => axios.get(`${API_URL}/export/brands`, { responseType: 'blob' });
export const exportVendorAnalyticsExcel = (params) => axios.get(`${API_URL}/export/vendor-analytics`, { params, responseType: 'blob' });
export const exportItemAnalyticsExcel = (params) => axios.get(`${API_URL}/export/item-analytics`, { params, responseType: 'blob' });
export const exportStockToExcel = (inventoryId) => {
  const params = inventoryId ? { inventory_id: inventoryId } : {};
  return axios.get(`${API_URL}/export/inventory`, { params, responseType: 'blob' });
};
export const exportTransactionsToExcel = (params) => {
  return axios.get(`${API_URL}/export/reports`, { params, responseType: 'blob' });
};

// Users
export const getUsers = () => axios.get(`${API_URL}/users`);
export const createUser = (data) => axios.post(`${API_URL}/users`, data);
export const updateUser = (id, data) => axios.put(`${API_URL}/users/${id}`, data);
export const toggleUserActive = (id) => axios.patch(`${API_URL}/users/${id}/toggle-active`);
export const deleteUser = (id) => axios.delete(`${API_URL}/users/${id}`);
export const adminResetPassword = (id, data) => axios.post(`${API_URL}/users/${id}/reset-password`, data);
export const resendInvitation = (id) => axios.post(`${API_URL}/users/${id}/resend-invitation`);

// Seed
export const seedDatabase = () => axios.post(`${API_URL}/seed`);

// Delete Invoice
export const deleteInvoice = (invoiceNumber, password) => axios.post(`${API_URL}/invoices/${invoiceNumber}/delete`, { password });

// Settings
export const getSettings = () => axios.get(`${API_URL}/settings`);
export const updateSettings = (data) => axios.put(`${API_URL}/settings`, data);

// Admin Data Management - Reset
export const resetItems = (data) => axios.post(`${API_URL}/admin/reset/items`, data);
export const resetVendors = (data) => axios.post(`${API_URL}/admin/reset/vendors`, data);
export const resetCategories = (data) => axios.post(`${API_URL}/admin/reset/categories`, data);
export const resetBrands = (data) => axios.post(`${API_URL}/admin/reset/brands`, data);
export const resetInventory = (data) => axios.post(`${API_URL}/admin/reset/inventory`, data);
export const resetUsers = (data) => axios.post(`${API_URL}/admin/reset/users`, data);

// Admin Data Management - Templates
export const downloadTemplate = (type) => axios.get(`${API_URL}/admin/templates/${type}`, { responseType: 'blob' });

// Admin Data Management - Import
export const importFile = (type, file, options = {}) => {
  const formData = new FormData();
  formData.append('file', file);
  const params = new URLSearchParams();
  if (options.preview) params.append('preview', 'true');
  if (options.update_existing) params.append('update_existing', 'true');
  const q = params.toString() ? `?${params.toString()}` : '';
  return axios.post(`${API_URL}/admin/import/${type}/upload${q}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// Image Uploads
export const uploadImage = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API_URL}/uploads/images`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
export const uploadImageFromUrl = (url) => axios.post(`${API_URL}/uploads/images/from-url`, { url });
export const deleteImage = (id) => axios.delete(`${API_URL}/uploads/images/${id}`);
export const imageUrl = (id) => {
  const token = localStorage.getItem('token');
  return `${API_URL}/uploads/images/${id}${token ? `?auth=${encodeURIComponent(token)}` : ''}`;
};
